
import React, { useState } from "react";

const TubeFittingsSection = () => {
  const [formData, setFormData] = useState({
    fittingType: "",
    shape: "",
    end: "",
    size: "",
    material: "",
    additionalProcess: "",
    supply: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.fittingType) newErrors.fittingType = "Fitting Type is required.";
    if (!formData.shape) newErrors.shape = "Shape is required.";
    if (!formData.end) newErrors.end = "End is required.";
    if (!formData.size) newErrors.size = "Size is required.";
    if (!formData.material) newErrors.material = "Material is required.";
    if (!formData.additionalProcess)
      newErrors.additionalProcess = "Additional Process is required.";
    if (!formData.supply) newErrors.supply = "Supply is required.";

    setErrors(newErrors);

    // Return true if there are no errors
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      console.log("Form submitted successfully:", formData);
      // Add your submission logic here
    } else {
      console.log("Validation failed.");
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-12 col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Tube Fittings</h4>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="mb-3 row">
                  <div className="col-md-4">
                    <label className="col-form-label">Fitting Type</label>
                    <input
                      name="fittingType"
                      value={formData.fittingType}
                      onChange={handleChange}
                      type="text"
                      className={`form-control ${
                        errors.fittingType ? "is-invalid" : ""
                      }`}
                      placeholder="Enter Fitting Type"
                    />
                    {errors.fittingType && (
                      <span className="text-danger">{errors.fittingType}</span>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="col-form-label">Shape</label>
                    <input
                      name="shape"
                      value={formData.shape}
                      onChange={handleChange}
                      type="text"
                      className={`form-control ${
                        errors.shape ? "is-invalid" : ""
                      }`}
                      placeholder="Enter Shape"
                    />
                    {errors.shape && (
                      <span className="text-danger">{errors.shape}</span>
                    )}
                  </div>

                  <div className="col-md-4">
                    <label className="col-form-label">End</label>
                    <input
                      name="end"
                      value={formData.end}
                      onChange={handleChange}
                      type="text"
                      className={`form-control ${
                        errors.end ? "is-invalid" : ""
                      }`}
                      placeholder="Enter End"
                    />
                    {errors.end && (
                      <span className="text-danger">{errors.end}</span>
                    )}
                  </div>
                </div>

                <div className="mb-3 row">
                <div className="col-md-4">
                    <label className="col-form-label">Size</label>
                    <input
                      name="size"
                      value={formData.size}
                      onChange={handleChange}
                      type="text"
                      className={`form-control ${
                        errors.size ? "is-invalid" : ""
                      }`}
                      placeholder="Enter Size"
                    />
                    {errors.size && (
                      <span className="text-danger">{errors.size}</span>
                    )}
                  </div>

                  <div className="col-md-4">
                    <label className="col-form-label">Material</label>
                    <input
                      name="material"
                      value={formData.material}
                      onChange={handleChange}
                      type="text"
                      className={`form-control ${
                        errors.material ? "is-invalid" : ""
                      }`}
                      placeholder="Enter Material"
                    />
                    {errors.material && (
                      <span className="text-danger">{errors.material}</span>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="col-form-label">Additional Process</label>
                    <input
                      name="additionalProcess"
                      value={formData.additionalProcess}
                      onChange={handleChange}
                      type="text"
                      className={`form-control ${
                        errors.additionalProcess ? "is-invalid" : ""
                      }`}
                      placeholder="Enter Additional Process"
                    />
                    {errors.additionalProcess && (
                      <span className="text-danger">
                        {errors.additionalProcess}
                      </span>
                    )}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-md-4">
                    <label className="col-form-label">Supply</label>
                    <input
                      name="supply"
                      value={formData.supply}
                      onChange={handleChange}
                      type="text"
                      className={`form-control ${
                        errors.supply ? "is-invalid" : ""
                      }`}
                      placeholder="Enter Supply"
                    />
                    {errors.supply && (
                      <span className="text-danger">{errors.supply}</span>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TubeFittingsSection;
